module.exports = __webpack_public_path__ + "static/media/screenshot3.9cd75ec0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/screenshot3.jpeg
// module id = 289
// module chunks = 0